<template>
    <v-dialog v-model="isActive" width="380" :titulo="titulo" persistent transition="dialog-bottom-transition">
        <v-card>
            <v-card-title class="headline justify-center">{{ titulo }}</v-card-title>
            <div class="d-flex justify-center ma-5">
                <v-icon color="primary" size="100">mdi-timer-alert-outline</v-icon>
            </div>
            <v-card-text class="text-body-1 black--text d-flex justify-center">
                Tu sesión está por terminar.
            </v-card-text>
            <v-card-text class="d-flex flex-column align-center">
                <v-btn width="260px" @click="refresca" elevation="0" color="primary" class="pa-5">
                    Continuar sesión
                </v-btn>
                <v-btn width="260px" @click="cerrarDialogo" outlined color="secondary" class="mt-1 pa-5">
                    Cerrar sesión
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
    components: {

    },
    props: {
        titulo: {
            type: String,
            default: '¿Estás ahí?',
        },
        timeout: {
            required: false,
        },
    },
    data() {
        return {
            isActive: false,
            intervaloEspera: null,
            timeOutModal: null,
            estoyContando: false,
            componentKey: 0,
        }
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion', 'refreshToken', 'nroafi']),

        reinicioDialogoLogout() {
            this.$parent.reinicioDialogoLogout();
        },
        forceRerender() {
            // console.log('reinicio key de countdown ..')
            this.componentKey += 1;
        },
        abrirDialog() {
            let vm = this
            vm.isActive = true
            //console.log('abrimos modal aviso ..')
        },
        cerrarDialogo() {
            // clearInterval(this.intervaloEspera); // Detener el contador
            // clearTimeout(this.timeOutModal); 
            // this.forceRerender()
            // this.reinicioDialogoLogout()
            // this.estoyContando = false
            this.isActive = false
            this.cerrarSesion();
        },
        refresca() {
            this.refreshToken()
            this.isActive = false
            //this.cerrarDialogo()
        },
    },
}

</script>

<style>
.count-down .percent[data-v-494d44b0] {
    position: relative;
}

.count-down .percent-text[data-v-494d44b0] {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #00a0df;
    font-size: 50px;
    line-height: 1;
    font-weight: 700;
    transition: all 0.5s linear;
}

.count-down .percent svg[data-v-494d44b0] {
    margin: 0 auto;
    position: relative;
    display: flex;
}

.count-down .percent svg circle[data-v-494d44b0] {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: #fff;
    stroke-width: 10;
    stroke-linecap: round;
    transform: translate(5px, 5px);
}

.count-down .percent svg circle[data-v-494d44b0]:last-child {
    stroke: #00a0df;
    transition: all 0.5s linear;
    position: absolute;
    transform: translate(5px, -5px) rotate(-90deg);
    transform-origin: center center;
}
</style>